import { styled } from '../../../Utilities';
import { ChoiceGroupOptionBase } from './ChoiceGroupOption.base';
import { getStyles } from './ChoiceGroupOption.styles';
export var ChoiceGroupOption = styled(ChoiceGroupOptionBase, getStyles, undefined, {
  scope: 'ChoiceGroupOption'
});